import { render, staticRenderFns } from "./OpenableUserName.vue?vue&type=template&id=03f67924&"
import script from "./OpenableUserName.vue?vue&type=script&lang=ts&"
export * from "./OpenableUserName.vue?vue&type=script&lang=ts&"
import style0 from "./OpenableUserName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports